// プロジェクトコンテキスト Resolver
// URL の projectId に対応するプロジェクトを ProjectsStore に選択状態として設定する
import { inject } from '@angular/core';
import { type ActivatedRouteSnapshot, type ResolveFn } from '@angular/router';

import { ProjectsStore } from '../projects.store';

/**
 * projectContextResolver
 * projects/:projectId ルートで実行される。
 * projectsStore.selectProject(projectId) を呼び出して選択プロジェクトを確定させる。
 * groupsStore は参照しない（features 間越境を避けるため）。
 */
export const projectContextResolver: ResolveFn<boolean> = async (
  route: ActivatedRouteSnapshot,
) => {
  const projectsStore = inject(ProjectsStore);

  const projectId = route.params['projectId'] as string | undefined;
  if (!projectId) return true;

  await projectsStore.selectProject(projectId);
  return true;
};
